<h2> Markit iBoxx indices - selective list </h2>
<p> Please click on each Index Name to see the constituents list and weights. </p>
<p> The list below includes Markit iBoxx indices used for UCITS funds.</p>

<p> Any omissions from this list should be notified to <span class="pointer-cursor link" (click)="goToLink('iBoxx@markit.com')">iBoxx@markit.com</span></p>

<p>Index rules are publically available and can be found
  <span class="link" (click)="goToLink('http://www.markit.com/Documentation/Product/IBoxx/Rules_Benchmark')">here</span>
  for the benchmark indices and here for the liquid indices
</p>

<div>
  <ag-grid-angular
    style="width: 100%;"
    class="ag-theme-balham"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [domLayout]="'autoHeight'"
    (gridReady)="onGridReady($event)"
    [pagination]="true"
    [paginationPageSize]="pagingInfo.pageSize"
    rowSelection="single"
    (sortChanged)="onSortChanged($event)"
    (selectionChanged)="onRowSelected()">
  </ag-grid-angular>
  <app-pagination-control *ngIf="rowData.length > 0" [input]="this.pagingInfo" (pageChanged)="changePage()"></app-pagination-control>
</div>
